import TenantLeaseForm from './TenantLeaseForm'

export default TenantLeaseForm
